
        Component.define('page-home', (el, params) => {
            /**
 * Cada componente recebe as variáveis explicadas abaixo
 *
 * @param {HTMLElement} el - Elemento DOM que seleciona o componente em si
 * @param {Object} params  - Parâmetros para serem utilizados
 */

const $el = $(el);
/*
$('[data-component="modal"]').trigger('modal:open', [
    {
        title: 'Comunicado',
        message: '',
        name: 'modal-bifinhos'
    }
]);*/

        });